const getAllBadges = () => {
    return {
        0: {
            name: 'Loyal Logger',
            description: 'You checked in for 60 consecutive days',
            imageUrl: '/images/loyal-logger.svg',
        },
        1: {
            name: 'Calendar Completer',
            description: 'You checked in for a total of 30 days',
            imageUrl: '/images/calendar-completer.svg',
        },
        2: {
            name: 'Loyal 7',
            description: 'You checked in for 7 consecutive days',
            imageUrl: '/images/lucky-7.svg',
        },
        3: {
            name: 'Newcomer\'s Greeting',
            description: 'You checked in for the first time',
            imageUrl: '/images/newcomers-greeting.svg',
        },
    };
};

export { getAllBadges };
